
  import { defineComponent, onBeforeUnmount, onMounted, ref } from 'vue';
  import { Button, generateCheckClickOutside, Icon, Typography } from '@voximplant/spaceui';
  import CallInfo from '@/components/calls/CallInfo.vue';
  import { useI18n } from 'vue-i18n';
  import DropdownList from '@/components/common/DropdownList.vue';
  import {
    $currentActiveCallId,
    activeCalls,
    currentSelectCall,
    openCallState,
    setSelectCall,
  } from '@/store/calls/index';
  import { useStore } from 'effector-vue/composition';
  import { $settings } from '@/store/settings';

  export default defineComponent({
    name: 'ActiveCall',
    components: { DropdownList, CallInfo, Typography, Button, Icon },
    setup() {
      const { t } = useI18n();
      const select = ref<HTMLDivElement | null>(null);
      const calls = useStore(activeCalls);
      const isOpen = ref(false);
      const checkClickOutside = generateCheckClickOutside(select);
      const selectCall = useStore(currentSelectCall);
      const currentActiveCallId = useStore($currentActiveCallId);
      const settings = useStore($settings);

      const onClickOutside = (event: MouseEvent) => {
        if (checkClickOutside(event) && isOpen.value) {
          isOpen.value = !isOpen.value;
        }
      };

      const closeSelect = (event: KeyboardEvent) => {
        if (event.key === 'Escape' && isOpen.value) isOpen.value = false;
      };

      onMounted(() => {
        document.addEventListener('click', onClickOutside, { capture: true });
        document.addEventListener('keydown', closeSelect);
      });

      onBeforeUnmount(() => {
        document.removeEventListener('click', onClickOutside);
        document.removeEventListener('keydown', closeSelect);
      });

      return {
        t,
        isOpen,
        select,
        calls,
        setSelectCall,
        selectCall,
        settings,
        currentActiveCallId,
        openCallState,
      };
    },
  });
